import {Botao, PaginaLogada} from "../../componentes";
import {useEffect, useState} from "react";
import {exibirMensagemErro, formatarData, formatarDinheiroItl, USUARIO, xfetch} from "../../util";
import {BOTAO, ICONE} from "../../config/constantes/constantes";
import {Card} from "../../componentes/card/Card";
import {useNavigate} from "react-router-dom";

export default function MinhasDemandas() {

  const navegacao = useNavigate()
  const [dods, setDods] = useState([])
  const [isCarregando, setIsCarregando] = useState(false)

  const consultaDods = () => {
    setIsCarregando(true)
    let usuario = JSON.parse(localStorage.getItem(USUARIO));
    xfetch(`/demanda/usuario/${usuario.id}`)
      .then(res => res.json())
      .then(dados => setDods(dados) & setIsCarregando(false))
      .catch((e) => setIsCarregando(false) & exibirMensagemErro('Erro ao carregar demandas ' + e.message))
  }

  useEffect(() => {
    consultaDods()
  }, [])

  function valorTotalItens(dod) {
    let total = 0;
    dod.items.map((v) => {
      total += v.quantidade * v.valorUnitario
      return total
    })
    return total.toFixed(2);
  }

  return (
    <PaginaLogada titulo="Meus DODs" isCarregando={isCarregando}>
      <Card titulo="Listagem">
        <div className="row">

          <div className="col-12">
            <table className="table table-hover table-striped table-bordered table-responsive-lg">
              <thead>
              <tr>
                <th>Unidade</th>
                <th>Data de envio</th>
                <th>Qtd de itens</th>
                <th>Valor Final</th>
                <th>Ações</th>
              </tr>
              </thead>

              <tbody>
              {dods.map((v, k) => {
                return (
                  <tr key={k}>
                    <td>{v.unidadeRequisitante}</td>
                    <td>{formatarData(v.dataSolicitacao)}</td>
                    <td>{v.items.length}</td>
                    <td>{formatarDinheiroItl(valorTotalItens(v))}</td>
                    <td> <Botao icone={ICONE.TIPO.INFO} tamanho={BOTAO.TAMANHO.PEQUENO} onClick={() => navegacao('/visualizarDemanda/'+v.id)}/> </td>
                  </tr>
                )
              })}

              </tbody>
            </table>
          </div>

        </div>
      </Card>
    </PaginaLogada>
  );
}